class ImageZoom extends HTMLElement {
  constructor() {
    super();
    this.settings = {
      zoom: 0.1,
      maxZoom: false,
      initialZoom: 1,
    };
    this.image = null;
    this.bgWidth = 0;
    this.bgHeight = 0;
    this.bgPosX = 0;
    this.bgPosY = 0;
    this.previousEvent = null;
  }

  connectedCallback() {
    this.image = this.querySelector('img');
    if (this.image) {
      if (this.image.complete && this.image.naturalHeight !== 0) {
        this.initialize();
      } else {
        this.image.addEventListener('load', this.onImageLoad.bind(this));
      }
    }
  }

  setSrcToBackground() {
    const img = this.image;
    img.style.backgroundRepeat = 'no-repeat';
    img.style.backgroundImage = `url("${img.src}")`;
    const cachedDataUrl = `data:image/svg+xml;base64,${window.btoa(
      '<svg xmlns="http://www.w3.org/2000/svg" width="' +
        img.naturalWidth +
        '" height="' +
        img.naturalHeight +
        '"></svg>'
    )}`;
    img.src = cachedDataUrl;
  }

  updateBgStyle() {
    const img = this.image;
    if (this.bgPosX > 0) {
      this.bgPosX = 0;
    } else if (this.bgPosX < this.width - this.bgWidth) {
      this.bgPosX = this.width - this.bgWidth;
    }

    if (this.bgPosY > 0) {
      this.bgPosY = 0;
    } else if (this.bgPosY < this.height - this.bgHeight) {
      this.bgPosY = this.height - this.bgHeight;
    }

    img.style.backgroundSize = `${this.bgWidth}px ${this.bgHeight}px`;
    img.style.backgroundPosition = `${this.bgPosX}px ${this.bgPosY}px`;
  }

  reset() {
    this.bgWidth = this.width;
    this.bgHeight = this.height;
    this.bgPosX = this.bgPosY = 0;
    this.updateBgStyle();
  }

  onwheel(e) {
    const img = this.image;
    e.preventDefault();

    let deltaY = e.deltaY || -e.wheelDelta;
    const rect = img.getBoundingClientRect();
    const offsetX = e.pageX - rect.left - window.pageXOffset;
    const offsetY = e.pageY - rect.top - window.pageYOffset;

    const bgCursorX = offsetX - this.bgPosX;
    const bgCursorY = offsetY - this.bgPosY;
    const bgRatioX = bgCursorX / this.bgWidth;
    const bgRatioY = bgCursorY / this.bgHeight;

    if (deltaY < 0) {
      this.bgWidth += this.bgWidth * this.settings.zoom;
      this.bgHeight += this.bgHeight * this.settings.zoom;
    } else {
      this.bgWidth -= this.bgWidth * this.settings.zoom;
      this.bgHeight -= this.bgHeight * this.settings.zoom;
    }

    if (this.settings.maxZoom) {
      this.bgWidth = Math.min(this.width * this.settings.maxZoom, this.bgWidth);
      this.bgHeight = Math.min(
        this.height * this.settings.maxZoom,
        this.bgHeight
      );
    }

    this.bgPosX = offsetX - this.bgWidth * bgRatioX;
    this.bgPosY = offsetY - this.bgHeight * bgRatioY;

    if (this.bgWidth <= this.width || this.bgHeight <= this.height) {
      this.reset();
    } else {
      this.updateBgStyle();
    }
  }

  initialize() {
    const img = this.image;
    this.setSrcToBackground();

    const computedStyle = window.getComputedStyle(img, null);
    this.width = parseInt(computedStyle.width, 10);
    this.height = parseInt(computedStyle.height, 10);

    this.bgWidth = this.width * this.settings.initialZoom;
    this.bgHeight = this.height * this.settings.initialZoom;
    this.bgPosX = -(this.bgWidth - this.width) / 2;
    this.bgPosY = -(this.bgHeight - this.height) / 2;

    img.style.backgroundSize = `${this.bgWidth}px ${this.bgHeight}px`;
    img.style.backgroundPosition = `${this.bgPosX}px ${this.bgPosY}px`;

    img.addEventListener('wheel', this.onwheel.bind(this));
  }
}

customElements.define('image-zoom', ImageZoom);
